module.exports = __webpack_public_path__ + "img/twitter-plain-icon.3715f1de.svg";